<template>
  <div>
    <v-row>
      <v-col cols="11">
        <v-simple-table dense v-if="benefits && content">
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="header in tableHeaders"
                  :key="header.name"
                  class="text-left"
                >
                  <p>{{ header.text }}</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, count) in tableBenefits"
                :key="`${item.title}-${count}`"
              >
                <td
                  v-for="(a, index) in item.audiences"
                  :key="`${item.name}-${a}-${index}`"
                  :class="a.tick ? getClass(count) : ''"
                  class="pa-3 text-center"
                >
                  <div v-if="a.tick">{{ item.title }}</div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import lodash from "lodash";
const fb = require("@/firebaseConfig.js");

export default {
  name: "ResultsUnitTable",

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
    this.getAudiences();
  },

  data() {
    return {
      content: null,
      audiencesFromExercise: null,
      selectedItem: {},
      currentCount: 0,
      colors: [
        { bg: "green lighten-1", text: "black--text" },
        { bg: "red darken-1", text: "white--text" },
        { bg: "purple", text: "white--text" },
        { bg: "pink darken-1", text: "white--text" },
        { bg: "deep-purple lighten-2", text: "white--text" },
        { bg: "indigo", text: "white--text" },
        { bg: "cyan", text: "black--text" },
        { bg: "teal", text: "white--text" },
        { bg: "green", text: "white--text" },
        { bg: "lime", text: "black--text" },
        { bg: "amber", text: "black--text" },
        { bg: "orange lighten-2", text: "black--text" },
        { bg: "deep-orange darken-2", text: "white--text" },
        { bg: "brown", text: "white--text" },
      ],
    };
  },
  props: {
    attributes: {
      type: Array,
      default: () => {},
    },
    benefits: {
      type: Array,
      default: () => {},
    },
    showControls: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    lang: {
      type: String,
      default: "exercise_benefits_bl",
    },
  },

  computed: {
    tableHeaders() {
      if (this.audiences) {
        const headers = [];
        this.audiences.forEach((x) => {
          headers.push({
            text: x.title,
            value: x.title,
          });
        });
        return headers;
      } else {
        return [];
      }
    },
    tableBenefits() {
      if (this.benefits) {
        const benefits = [];

        this.benefits.forEach((x) => {
          const arr = [];
          this.audiences.forEach((a) => {
            arr.push({
              title: a.title,
              tick: x.audience.filter((z) => z === a.title).length
                ? true
                : false,
            });
          });

          benefits.push({
            title: x.title,
            audiences: arr,
            length: arr.filter((x) => x.tick).length,
          });
        });

        const orderedArr = lodash.orderBy(benefits, "length", "desc");
        return orderedArr;
      } else {
        return [];
      }
    },
    audiences() {
      if (this.content && this.audiencesFromExercise) {
        console.log("get audiences from exercise");
        return this.content.exercise_benefits.getAudiencesFromExercise
          ? this.audiencesFromExercise
          : this.content.exercise_benefits.step1.dropdown;
      } else {
        return this.content.exercise_benefits.step1.dropdown;
      }
    },
  },

  methods: {
    getClass(count) {
      const theme = this.colors[count];
      this.incCount();
      return theme && [theme.bg, theme.text];
    },
    incCount() {
      if (this.currentCount < this.colors.length) {
        this.currentCount += 1;
      } else {
        this.currentCount = 0;
      }
    },
    showOverlay(title) {
      const item = this.benefits.find((x) => x.title === title);
      if (item) {
        this.selectedItem = item;
      }
    },
    getAudiences() {
      let ref = fb.audienceExCollection.where(
        "pid",
        "==",
        this.$route.params.id
      );
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items && items.length) {
            const body = items[0].doc.matrix;
            this.audiencesFromExercise = [...body.q1, ...body.q2, ...body.q3];
          }
        })
        .catch(function() {});
    },
  },
};
</script>

<style lang="scss" scoped>
.benefits-table {
  td {
    padding: 2rem;
  }
}
</style>
